<template>
    <div class="list">
      <i v-if="play === false" @click="playMusic(true)" class="fas fa-play-circle"></i>
      <i v-else-if="play === true" @click="playMusic(false)" class="fas fa-pause-circle"></i>
    </div>
  </template>
  
  <script>
  import skylikeDawn from "../../assets/music/skylikeDawn.mp3";
  
  export default {
    name: "button-play-audio",
    data() {
      return {
        navListSize: 0,
        play: false,
        audio: new Audio(skylikeDawn), // Menggunakan import untuk mengakses file audio
      };
    },
    methods: {
      playMusic(condition) {
        this.play = condition;
        if (condition) {
          this.audio.play();
          console.log(condition);
        } else {
          this.audio.pause();
          console.log(condition);
        }
      },
    },
  };
  </script>
  
  <style scoped lang="scss">
  @import "@/assets/scss/sidebar.scss";
  </style>
  